<template>
  <app-loading-container
    class="w-full px-4 py-6 mb-32 lg:py-16 sm:px-10"
    :loading="loading"
    :loaded="loaded"
    :error-loading="errorLoading"
  >
    <div>
      <div class="space-x-0 space-y-8 lg:flex lg:space-x-8 lg:space-y-0">
        <div class="w-full lg:w-3/5">
          <div class="px-8 py-16 bg-gray-type-2 rounded-xl">
            <template v-if="loading">
              <div class="animate-pulse">
                <div class="flex items-center space-x-4">
                  <div class="w-20 h-20 bg-gray-400 rounded-full"></div>
                  <div class="flex-1 space-y-4">
                    <div class="w-2/6 h-4 bg-gray-400 rounded"></div>
                    <div class="w-1/6 h-4 bg-gray-400 rounded"></div>
                  </div>
                </div>
                <div class="w-full h-10 mt-16 bg-gray-400 rounded"></div>
                <div class="w-1/2 h-4 mt-4 bg-gray-400 rounded"></div>
              </div>
            </template>
            <template v-else>
              <div class="flex items-center px-2 space-x-4">
                <div>
                  <svg
                    width="72"
                    height="72"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <defs>
                      <rect id="a" x="0" y="0" width="72" height="72" rx="36" />
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                      <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
                      <use fill="#1A1E1D" xlink:href="#a" />
                      <g opacity=".677" mask="url(#b)" fill-rule="nonzero">
                        <g transform="translate(17.25 18)">
                          <path
                            d="M26.809 9.191V2.237A2.007 2.007 0 0024.112.352L1.187 8.778C.48 9.038.007 9.709 0 10.463v19.708C0 33.391 2.61 36 5.829 36h28.34a2.589 2.589 0 002.597-2.589v-21.63c0-1.43-1.16-2.59-2.589-2.59h-7.368z"
                            fill="#41534D"
                          />
                          <path
                            d="M24.112.352L1.187 8.778a1.77 1.77 0 00-.666.436h26.288V2.237A2.006 2.006 0 0024.112.352z"
                            fill="#728881"
                          />
                          <circle
                            fill="#728881"
                            cx="29.106"
                            cy="22.596"
                            r="1.532"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div>
                  <div class="text-sm font-medium text-white">
                    WALLET BALANCE
                  </div>
                  <div class="mt-2 text-2xl font-bold text-white">
                    ₦ {{ $filters.money(wallet.amount) }}
                  </div>
                </div>
              </div>
              <form class="mt-12" @submit.prevent="fundWallet">
                <div>
                  <label
                    class="text-xs font-medium text-white"
                    for="funding-amount"
                    >Enter funding amount</label
                  >
                  <div class="relative flex items-center mt-2">
                    <div
                      class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
                    >
                      <span class="font-medium text-gray-type-2 sm:text-sm"
                        >₦</span
                      >
                    </div>
                    <app-currency-input
                      v-model="fundingAmount"
                      required
                      type="text"
                      id="funding-amount"
                      class="w-full h-12 px-3 py-4 pl-8 text-xs font-medium bg-white outline-none placeholder-gray-type-3 focus:outline-none"
                    />
                    <app-button
                      type="submit"
                      class="justify-center w-1/3 h-12 py-3 text-xs font-bold text-center text-white px-9 bg-green-type-1"
                      :loading="fundingWallet"
                      :disabled="fundingWallet || !amountValid"
                    >
                      Fund Wallet
                    </app-button>
                  </div>
                </div>
              </form>
              <div class="flex items-center mt-3">
                <div>
                  <svg
                    width="18"
                    height="12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="#FFF" fill-rule="nonzero">
                      <path
                        d="M0 4.905v4.648a2.423 2.423 0 002.423 2.423h13.112a2.423 2.423 0 002.423-2.423V4.905a.421.421 0 00-.422-.421H.421A.421.421 0 000 4.905zm4.484 2.95H3.36a.738.738 0 110-1.475h1.124a.738.738 0 110 1.475zM17.958 2.587v-.152A2.423 2.423 0 0015.535.012H2.423A2.423 2.423 0 000 2.435v.152c0 .233.189.422.421.422h17.115a.421.421 0 00.422-.422z"
                      />
                    </g>
                  </svg>
                </div>
                <div class="ml-2 text-sm font-bold text-white">
                  Fund with debit/credit card
                </div>
                <div
                  class="inline-flex items-center ml-2 font-medium text-gray-type-8 text-xxs"
                >
                  <span>Your transactions are secured by</span
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="58"
                    height="12"
                    class="ml-1"
                  >
                    <g fill="none">
                      <path
                        fill="#0BA4DB"
                        d="M9.565 0H.555A.557.557 0 000 .556v1c0 .305.25.555.555.555h8.983c.305 0 .554-.25.554-.555v-1A.517.517 0 009.565 0zm0 5.583H.555A.557.557 0 000 6.139v1c0 .305.25.555.555.555h8.983c.305 0 .554-.25.554-.555v-1a.517.517 0 00-.527-.556zM5.628 8.39H.555A.557.557 0 000 8.945v1c0 .306.25.556.555.556h5.073c.305 0 .555-.25.555-.556v-1a.557.557 0 00-.555-.555zm4.492-5.583H.555A.557.557 0 000 3.362v1c0 .306.25.556.555.556h9.565c.305 0 .554-.25.554-.556v-1a.557.557 0 00-.554-.555z"
                      ></path>
                      <path
                        fill="#ffffff"
                        d="M15.846 9.398a.236.236 0 00.244-.242V7.12h1.424c.709 0 1.29-.229 1.744-.686.455-.457.691-1.037.71-1.74 0-.696-.229-1.277-.688-1.744-.46-.467-1.048-.7-1.766-.7h-3.011c-.07 0-.13.025-.18.074a.245.245 0 00-.073.178v6.654c0 .07.024.127.071.173.048.046.108.07.182.07h1.343zm.274-3.904v-1.65h1.096c.241 0 .44.078.595.233a.8.8 0 01.233.59c0 .235-.078.43-.233.587a.816.816 0 01-.595.24H16.12zm6.515 4.07c.243 0 .468-.04.676-.12.207-.078.392-.197.557-.355v.086c0 .066.024.123.073.17a.24.24 0 00.173.071H25.4a.22.22 0 00.163-.07.239.239 0 00.069-.171V4.608a.23.23 0 00-.066-.17.235.235 0 00-.171-.066h-1.29a.227.227 0 00-.237.236v.09a1.696 1.696 0 00-.557-.35 1.887 1.887 0 00-.676-.119c-.721 0-1.327.258-1.819.773-.492.514-.738 1.146-.738 1.894 0 .749.246 1.38.738 1.895a2.415 2.415 0 001.819.772zm.275-1.65a.964.964 0 01-.721-.306 1.024 1.024 0 01-.296-.74c0-.289.099-.535.296-.739.197-.203.437-.305.721-.305s.525.102.722.305c.197.204.295.45.295.74s-.098.536-.295.74a.969.969 0 01-.722.305zm4.683 3.959c.56 0 1.037-.148 1.433-.444.396-.295.678-.714.847-1.258l1.669-5.431c.038-.13.038-.23 0-.298-.038-.068-.113-.103-.224-.103H29.93a.288.288 0 00-.186.062.347.347 0 00-.11.181l-.658 2.693-.777-2.702a.38.38 0 00-.103-.179.261.261 0 00-.174-.055h-1.478c-.13 0-.22.036-.267.108-.048.071-.05.169-.005.293l1.54 4.43a.38.38 0 00.12.177.281.281 0 00.185.067h.296l-.19.486a.706.706 0 01-.249.338.66.66 0 01-.39.115.821.821 0 01-.275-.048 1.797 1.797 0 01-.34-.176.386.386 0 00-.28-.065.361.361 0 00-.231.17l-.434.657a.383.383 0 00-.072.231.301.301 0 00.09.203c.21.171.46.305.747.402.288.097.59.146.904.146zm6.563-2.31c.724 0 1.299-.158 1.725-.474.425-.315.638-.739.638-1.269 0-.404-.128-.737-.383-1-.256-.262-.629-.445-1.118-.549l-.967-.208a.556.556 0 01-.238-.095.189.189 0 01-.077-.152c0-.07.043-.126.13-.17a.7.7 0 01.323-.067c.156 0 .323.029.503.086.18.057.372.142.579.256.12.066.225.097.312.092a.362.362 0 00.245-.13l.472-.507c.086-.098.126-.19.122-.275-.005-.085-.054-.166-.146-.242-.2-.18-.495-.33-.886-.45a4.21 4.21 0 00-1.244-.18c-.648 0-1.178.163-1.589.488-.411.326-.617.733-.617 1.222 0 .392.122.72.367.983.244.264.588.44 1.03.528l.947.195a.866.866 0 01.327.118c.071.05.107.114.107.19 0 .075-.043.138-.129.187a.697.697 0 01-.347.073 1.63 1.63 0 01-.589-.118c-.202-.08-.4-.191-.593-.337-.124-.094-.227-.142-.31-.142a.42.42 0 00-.262.114l-.524.426c-.156.127-.207.27-.153.429.054.16.21.32.467.48.248.155.538.277.87.365.332.089.668.133 1.008.133zm5.117-.055c.334 0 .65-.052.947-.157.297-.104.536-.248.717-.432a.285.285 0 00.09-.199.376.376 0 00-.07-.228l-.449-.67c-.06-.085-.125-.135-.193-.151-.065-.015-.143.002-.234.052l-.016.01a1.68 1.68 0 01-.263.125.638.638 0 01-.214.04.355.355 0 01-.272-.106.41.41 0 01-.1-.292V5.814h1.116a.24.24 0 00.243-.247V4.59a.224.224 0 00-.072-.168.237.237 0 00-.171-.069h-1.116v-1.04a.226.226 0 00-.07-.168.228.228 0 00-.168-.07h-1.424a.111.111 0 00-.11.103v.009l.003.483c.002.371 0 .595-.005.67h-.703c-.048.054-.054.614-.055.81v.418c0 .07.023.129.07.176.045.048.1.071.164.071h.524V7.87c0 .513.166.914.499 1.204.332.29.776.434 1.332.434zm4.476.055c.244 0 .469-.04.676-.118.207-.08.393-.198.557-.356v.086c0 .066.025.123.074.17a.239.239 0 00.173.071h1.285a.239.239 0 00.233-.241V4.608a.231.231 0 00-.067-.17.23.23 0 00-.17-.066h-1.29a.228.228 0 00-.238.236v.09a1.686 1.686 0 00-.557-.35 1.88 1.88 0 00-.676-.119c-.72 0-1.327.258-1.819.773-.491.514-.737 1.146-.737 1.894 0 .749.246 1.38.737 1.895a2.416 2.416 0 001.82.772zm.276-1.65a.965.965 0 01-.722-.305 1.023 1.023 0 01-.295-.74c0-.289.098-.535.295-.739.197-.203.438-.305.722-.305s.524.102.721.305c.197.204.296.45.296.74s-.099.536-.296.74a.966.966 0 01-.721.305zm6.076 1.65c.565 0 1.064-.124 1.495-.372a2.19 2.19 0 00.939-1.025.315.315 0 00.016-.273c-.036-.083-.115-.143-.235-.177l-.967-.29a.513.513 0 00-.24-.023c-.066.013-.147.074-.246.185a.888.888 0 01-.333.258c-.13.058-.273.088-.429.088a.984.984 0 01-.728-.304c-.2-.202-.3-.446-.3-.734 0-.287.1-.532.3-.734a.987.987 0 01.728-.303c.156 0 .299.03.429.088.13.058.241.144.333.258.095.11.176.172.243.184a.523.523 0 00.243-.023l.967-.29c.12-.034.199-.093.235-.177.037-.083.031-.174-.016-.272a2.188 2.188 0 00-.939-1.026c-.431-.248-.93-.372-1.495-.372-.78 0-1.443.26-1.988.777-.544.518-.817 1.148-.817 1.89s.273 1.372.817 1.89c.545.518 1.207.777 1.988.777zm4.451-.165a.228.228 0 00.167-.066.228.228 0 00.066-.166V7.158l1.29 2.088c.035.054.08.093.134.117a.644.644 0 00.242.035h1.257c.146 0 .241-.041.285-.123.045-.083.03-.18-.042-.295l-1.543-2.396 1.267-1.833c.066-.098.084-.19.052-.277-.032-.087-.106-.13-.224-.13h-1.237a.355.355 0 00-.184.049.455.455 0 00-.145.145l-1.152 1.784V2.487a.229.229 0 00-.066-.17.231.231 0 00-.171-.067h-1.295a.231.231 0 00-.171.066.231.231 0 00-.067.171v6.679a.22.22 0 00.071.166.252.252 0 00.176.066h1.29z"
                      ></path>
                    </g>
                  </svg>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="flex w-full lg:w-2/5">
          <div class="px-8 py-16 bg-gray-type-2 text-gray-type-8 rounded-xl">
            <div class="flex items-center">
              <div>
                <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                  <g fill="#FFF" fill-rule="nonzero">
                    <path
                      d="M12.388 8.386h1.875v4.489h-1.875zM8.838 8.386h1.875v4.489H8.838zM5.287 8.386h1.875v4.489H5.287zM1.737 8.386h1.875v4.489H1.737zM14.888 6.98v-.47H1.112v.47c0 .258.21.468.469.468H14.42c.258 0 .468-.21.468-.469zM15.531 13.813H.469A.469.469 0 000 14.28v1.25c0 .26.21.469.47.469H15.53c.259 0 .469-.21.469-.469v-1.25a.469.469 0 00-.469-.469zM.469 5.573H15.53a.469.469 0 00.246-.868L8.246.07a.469.469 0 00-.492 0L.223 4.705a.469.469 0 00.246.868zM7.68 2.757h.638a.469.469 0 110 .938H7.68a.469.469 0 110-.938z"
                    />
                  </g>
                </svg>
              </div>
              <div class="ml-2 text-sm font-bold text-white">
                Fund with Bank Transfer/Deposit
              </div>
            </div>
            <div class="mt-2 font-medium text-xxs">
              <p>
                You can add money to your wallet by simply sending money to this
                account number we created just for you.
              </p>
            </div>
            <div class="mt-4">
              <div class="inline-flex items-center">
                <div class="text-xs font-medium">Bank name:</div>
                <div class="ml-2 text-xs font-bold text-white">
                  Diamond Bank
                </div>
              </div>
              <div class="inline-flex items-center mt-2">
                <div class="text-xs font-medium">Account name:</div>
                <div class="ml-2 text-xs font-bold text-white">
                  Babajide Sanwo-olu
                </div>
              </div>
              <div class="inline-flex items-center mt-2">
                <div class="text-xs font-medium">Account number:</div>
                <div class="ml-2 text-xs font-bold text-white">0070896021</div>
              </div>
            </div>
            <button class="flex items-center space-x-2 mt-9">
              <span>
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0h24v24H0z" />
                    <path
                      stroke="#FFF"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15.75 15.75h4.5v-12h-12v4.5"
                    />
                    <path
                      stroke="#FFF"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M3.75 8.249h12v12h-12z"
                    />
                  </g>
                </svg>
              </span>
              <span class="text-xs font-bold text-white"
                >Copy account info</span
              >
            </button>
          </div>
        </div>
      </div>
      <div class="mt-8">
        <div class="ml-8 font-bold text-gray-type-2">Account activities</div>
        <div class="mt-4 bg-white">
          <div class="px-8 py-3">
            <div class="flex items-center space-x-4">
              <a
                href="#"
                class="pb-2 text-xs font-bold border-b text-green-type-1 border-green-type-1"
                >My transactions</a
              >
              <a href="#" class="pb-2 text-xs font-medium text-gray-type-8"
                >My invoices</a
              >
            </div>
          </div>
          <app-table
            :items="transactions"
            :fields="transactionsFields"
            :loading="loading"
            :error-loading="errorLoading"
          >
            <template v-slot:date="{ item }">
              <span class="text-xs font-medium text-gray-type-3">
                {{ $filters.dateTime(item.created_at) }}
              </span>
            </template>
            <template v-slot:type="{ item }">
              <span class="text-xs font-medium text-gray-type-3">
                {{ $filters.titleCase(item.type) }}
              </span>
            </template>
            <template v-slot:amount="{ item }">
              <span class="text-xs font-medium text-gray-type-3">
                ₦ {{ $filters.money(item.amount) }}
              </span>
            </template>
          </app-table>
        </div>
      </div>
    </div>
  </app-loading-container>
</template>

<script>
import { mapGetters } from "vuex";
import AppTable from "@/components/AppTable";
import paymentProcessor from "@/mixins/payment-processor";

export default {
  components: {
    AppTable,
  },
  data() {
    return {
      loading: false,
      loaded: false,
      errorLoading: false,
      wallet: null,
      transactions: [],
      fundingAmount: "",
      fundingWallet: false,
      transactionsFields: [
        { key: "date", label: "Date" },
        { key: "type", label: "Transaction type" },
        { key: "id", label: "Transaction ID" },
        { key: "amount", label: "Amount" },
      ],
    };
  },
  mixins: [paymentProcessor],
  created() {
    this.fetchWallet();
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    normalizedAmount() {
      return this.$filters.normalizeCurrency(this.fundingAmount);
    },
    amountValid() {
      return this.normalizedAmount >= 100;
    },
  },
  methods: {
    fetchWallet() {
      this.loading = true;

      this.errorLoading = this.loaded = false;

      this.$http
        .get(`/users/${this.user.id}/wallet`)
        .then((res) => {
          this.wallet = res.data.wallet;
          this.transactions = res.data.walletHistory;

          this.loaded = true;
        })
        .catch(() => {
          this.errorLoading = true;
        })
        .finally(() => (this.loading = false));
    },
    fundWallet() {
      this.fundingWallet = true;

      this.pay({
        amount: this.normalizedAmount,
        wallet_id: this.wallet.id,
        user_id: this.wallet.user_id,
        customer_email: this.user.email,
      })
        .then((res) => {
          if (res) {
            this.$toast.success("Your payment has been made successfully.");

            this.fetchWallet();

            this.fundingAmount = "";
          }
        })
        .catch(() => {
          this.$toast.error("Unable to process payment, please try again.");
        })
        .finally(() => (this.fundingWallet = false));
    },
  },
};
</script>